module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "LINESPACE",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EPV"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page vii. ",
      "epub:type": "pagebreak",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("God that berreth the crone of thornes")])]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Distru the prud of womens homes …")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("Curse")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Mother, Mother, I am coming")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Home to Jesus")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("And to Thee …")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("Hymn")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0